<template>
  <div class="banner-list-item">
    <div class="image-wrapper">
      <img :src="imageUrl" class="image" />
    </div>
    <div class="body">
      <router-link :to="to" class="link">
        <h3 class="title">
          {{ title ? title : t("feature.article.no_title") }}
        </h3>
        <p class="content">{{ content | article-content }}</p>
      </router-link>
      <p class="category">
        <img :src="categoryIconUrl" class="icon" />{{ categoryText }} &nbsp;
        <span v-if="isPin">Pinned banner</span>
      </p>
    </div>
    <div class="action">
      <button class="delete" @click="handleClickDelete">
        <img :alt="$t('label.delete')" src="/static/icons/trash.svg" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: null,
      default: undefined,
    },
    title: {
      type: null,
      default: undefined,
    },
    content: {
      type: null,
      default: undefined,
    },
    imageUrl: {
      type: null,
      default: undefined,
    },
    category: {
      type: null,
      default: undefined,
    },
    isPin: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    categoryText() {
      switch (this.category) {
        case "news":
          return "ข่าวประชาสัมพันธ์"
        case "activities":
          return "ข่าวกิจกรรม"
        case "privileges":
          return "ข่าวสิทธิพิเศษ"
        default:
          return ""
      }
    },
    categoryIconUrl() {
      switch (this.category) {
        case "news":
          return "/static/icons/sidebar-icon-news.svg"
        case "activities":
          return "/static/icons/sidebar-icon-activity.svg"
        case "privileges":
          return "/static/icons/sidebar-icon-privilege.svg"
        default:
          return ""
      }
    },
    to() {
      return {
        name: "ArticleDetail",
        params: { articleType: this.category, articleId: this.id },
      }
    },
  },
  methods: {
    handleClickDelete() {
      this.$emit("onDelete")
    },
  },
}
</script>

<style lang="scss" scoped>
.banner-list-item {
  display: flex;
  flex-flow: row nowrap;

  border-bottom: 1px solid #e0e0e0;
  padding: 15px 30px;
}

.image-wrapper {
  margin-right: 30px;
  background: #e0e0e0;

  overflow: hidden;

  border: 1px solid #e0e0e0;
  border-radius: 5px;
  width: 160px;
  height: 100px;
  flex: 0 0 160px;

  > .image {
    width: 160px;
    height: 100px;

    object-fit: cover;
    object-position: center;
  }
}

.body {
  flex-grow: 1;
  padding: 5px 0;
}

.body > .link {
  &:hover {
    text-decoration: none;

    > .title {
      text-decoration: underline;
    }

    > .content {
      text-decoration: none;
    }
  }

  > .title,
  > .content {
    margin: 0;
    line-height: 1.6;
  }

  > .title {
    font-size: 16px;
  }

  > .content,
  > .category {
    color: #616161;
  }

  > .content {
    font-size: 14px;
    height: 45px;
    overflow: hidden;
  }
}

.category {
  margin-top: 10px;
  font-size: 12px;

  > .icon {
    margin-left: -2px;
    margin-top: -2px;
    margin-right: 5px;
  }
}

.action {
  flex: 0 0 50px;
  width: 50px;

  text-align: right;

  > .delete {
    padding: 5px;
    border-radius: 50%;
    cursor: pointer;

    &:hover {
      background: #ccc;
    }
  }
}
</style>
